define('profile_emailpreferences.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('profile_emailpreferences', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"Email.Preferences.Custom\"></div>  ";
},"useData":true}, 'extensions/C3/SCAB2C2023/1.0.7/', 'extensions/C3/SCAB2C2023/1.0.7/', Handlebars);
});